import "../../assets/UFC_DC_RF_V1/scss/modules/anim.scss";
import "../../assets/UFC_DC_RF_V1/scss/modules/checklist.scss";
import "../../assets/UFC_DC_RF_V1/scss/modules/personaldetails.scss";
import "../../assets/UFC_DC_RF_V1/scss/modules/questionnaire.scss";
import "../../assets/UFC_DC_RF_V1/scss/modules/accordian.scss";


import GetVisitorsParams from "../../Utility/GetVisitorsParams";
import Footer from '../Includes/Layouts/UFC_DC_RF_V1/Footer';
import Questions from "../Includes/Layouts/UFC_DC_RF_V1/Questions";

const CreditQuest_UFC_DC_RF_V1 = () => {
    return (
        <>
            <div className='UFC_DC_RF_V1'>
                <GetVisitorsParams />
                <Questions/>
                <Footer />
            </div>
        </>
    )
}

export default CreditQuest_UFC_DC_RF_V1;